import React, { Component } from "react";
import BootstrapTable from 'react-bootstrap-table-next';
import {connect} from 'react-redux';
import { getDocumentsListColumns } from "./documentsList";
import { BaseUrl } from "../BaseUrl/BaseUrl";
import { sendMessage } from "../apa/actions";


@connect(
  state => {
    return {
      auth: state.apa
    }
  },
  dispatch => {
      return {
        sendMessage: (message, type) => dispatch(sendMessage({text: message, color: type}))
      }
  }
)


export default class CustomerDocumentsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      documents: []
    };
  }

  componentDidMount() {
    const headers = {
			Authorization: `Token ${this.props.auth.token}`,
			'Content-Type': 'application/json'
		};
    fetch(`${BaseUrl}/api/customers/documents`, {headers})
    .then(res => res.json())
    .then(documentsList => {
      this.setState({
        documents: documentsList
      })
    })
  }

  handleSave = (documentId, type) => {
    const headers = {
      Authorization: `Token ${this.props.auth.token}`,
      'Content-Type': 'application/json',
    };
    fetch(`${BaseUrl}/api/customers/documents/${documentId}/`, {
      method: 'PATCH',
      headers,
      body: JSON.stringify({ _type: type }),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error('Error occurred.');
        }
        return res.json();
      })
      .then(() => this.props.sendMessage('Änderungen gespeichert.', 'success'))
      .catch(() => this.props.sendMessage('Fehler aufgetreten.', 'danger'));
  };

  render() {
    const columns = getDocumentsListColumns({
      handleSave: this.handleSave,
    });

    return (
      <BootstrapTable
        keyField="id"
        data={this.state.documents}
        columns={columns}
      />
    );
  }
}
